import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "button"]
  static values = { step: { type: Number, default: 9 } }

  declare itemTargets: HTMLElement[]
  declare buttonTarget: HTMLElement
  declare stepValue: number

  connect() {
    this.updateButton()
  }

  show() {
    let count = 0
    for (const item of this.itemTargets) {
      if (item.hidden) {
        item.hidden = false
        count++
        if (count >= this.stepValue) break
      }
    }
    this.updateButton()
  }

  private updateButton() {
    const remaining = this.itemTargets.filter(el => el.hidden).length
    if (remaining === 0) {
      this.buttonTarget.remove()
    }
  }
}
